<template>
  <div
    v-if="backend_ready"
    class="lg:ml-2 lg:mt-6 xl:ml-2 xl:mt-6 p-2 bg-gray-200 shadow-md"
  >
    <div>
      <p
        class="lg:hidden xl:hidden font-raleway font-bold text-2xl text-mi-blue-500 uppercase"
      >
        Zoeken
      </p>
    </div>

    <button
      @click="showResults"
      class="lg:hidden xl:hidden w-full my-4 bg-mi-blue-500 text-gray-100 font-semibold py-2 border border-black rounded-lg shadow-lg"
    >
      {{ total_items }} accommodaties tonen
    </button>
    <hr class="mt-4" />
    <p class="mt-4 font-raleway text-m text-gray-800">
      Zoekresultaten filteren:
    </p>
    <Actor v-if="hasPermission('read other users')" />
    <Creator v-if="hasPermission('read other users')" />
    <ProvinceSearch />
    <MunicipalitySearch />
    <PlaceSearch />
    <hr class="mt-4" />
    <SportSearch />
    <SubstrateSearch />
    <ServiceSearch />
    <hr class="mt-4" />
    <IndoorSearch />
    <ShowFinishedTasks />
    <IncludeClosedAccommodatiesSearch />
  </div>
</template>

<script>
import ProvinceSearch from "../Search/ProvinceSearch";
import MunicipalitySearch from "../Search/MunicipalitySearch";
import PlaceSearch from "../Search/PlaceSearch";
import SportSearch from "../Search/SportSearch";
import SubstrateSearch from "../Search/SubstrateSearch";
import ServiceSearch from "../Search/ServiceSearch";
import ShowFinishedTasks from "../Search/ShowFinishedTasks.vue";
import IncludeClosedAccommodatiesSearch from "../Search/IncludeClosedAccommodatiesSearch.vue";
import IndoorSearch from "../Search/IndoorSearch";
import Actor from "../Search/Actor.vue";
import Creator from "../Search/Creator.vue";

export default {
  name: "SearchPane",
  components: {
    ProvinceSearch,
    MunicipalitySearch,
    PlaceSearch,
    SportSearch,
    SubstrateSearch,
    ServiceSearch,
    ShowFinishedTasks,
    IncludeClosedAccommodatiesSearch,
    IndoorSearch,
    Actor,
    Creator
  },
  computed: {
    total_items() {
      if (!this.$store.state.backend_data_loaded) return 0;
      return this.$store.state.backend_data.accommodaties["total_items"];
    },
    backend_ready() {
      return this.$store.state.backend_data_loaded;
    }
  },
  methods: {
    showResults() {
      this.$emit("showResults");
    }
  }
};
</script>
